import React, { useState } from 'react';
import {useHistory} from "react-router-dom";

import Link from '../components/Link';

export default function FourOhFour(props) {

    let homeUrl = '/'

    return (
        <div style={{textAlign: "center"}}>
            <h1 style={{color: "red"}}>404</h1>
            <div>
                This page does not exist. Go to <Link to={homeUrl}>Home</Link>.
            </div>
        </div>
    )
}
